module.exports = __webpack_public_path__ + "img/barBG.d7904399.jpg";